import { useNavigate } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import { SectionWrapper } from '../../../patterns';
import ROUTE_PATHS from '../../../routes/paths';
import ProposalTemplatesHistoryDetailView from './ProposalTemplatesHistoryDetailView';

const ProposalTemplatesHistoryDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentProposal } = useAppointmentProposals();
  if (!currentProposal) {
    return null;
  }

  return (
    <SectionWrapper
      maxWidth={'lg'}
      width={'100%'}
      header={'Past Proposal Details'}
      alignItems={'flex-start'}
      actionsButtons={{
        left: {
          label: 'Back',
          onClick: () =>
            navigate(
              ROUTE_PATHS.APPOINTMENT_PATH({
                appointmentId: currentProposal.appointmentId,
                appointmentProposalId: currentProposal.appointmentProposalId,
                path: 'options',
                extraPath: 'manage/templates/history',
              })
            ),
        },
      }}
    >
      <ProposalTemplatesHistoryDetailView />
    </SectionWrapper>
  );
};

export default ProposalTemplatesHistoryDetailPage;
